import React from "react";
import { useNavigate } from "react-router-dom";
import { Table, Tag, Button, Space, Typography, Popconfirm } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import useNewsletterTemplatesAdmin from "hooks/web-templates/useNewsletterTemplatesAdmin";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";

const { Title } = Typography;

export default function NewsletterTemplatesAdminPage() {
  const navigate = useNavigate();
  const { templates, loading, totalElements, deleteTemplate } =
    useNewsletterTemplatesAdmin();

  const columns = [
    { title: "Name", dataIndex: "name", key: "name" },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      render: (category) => category || "—",
    },
    {
      title: "Premium",
      dataIndex: "premium",
      key: "premium",
      width: 120,
      render: (premium) =>
        premium ? <Tag color="gold">Premium</Tag> : <Tag>Free</Tag>,
    },
    {
      title: "",
      key: "actions",
      width: 160,
      render: (_, record) => (
        <Space size={8}>
          <Button
            size="small"
            icon={<EditOutlined />}
            onClick={() =>
              navigate(`/ovizia/newsletter-templates/${record.id}/edit`)
            }
          >
            Edit
          </Button>
          <Popconfirm
            title="Delete this template?"
            description="This can't be undone."
            okText="Delete"
            okButtonProps={{ danger: true }}
            onConfirm={() => deleteTemplate(record.id)}
          >
            <Button size="small" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 24, fontFamily: "Inter" }}>

      <div className="d-flex justify-content-between align-items-center mb-3 mt-3 gap-3">
        <WidgetSectionTitle
          icon={["fab", "adn"]}
          title="Newsletter Templates"
          subtitle="Manage all Ovizia newsletter templates"
          transform="shrink-2"
          className="flex-1"
        />

        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate("/ovizia/newsletter-templates/create")}
          style={{ marginBottom: 16 }}
        >
          New Template
        </Button>
      </div>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={templates}
        loading={loading}
        pagination={false}
      />
    </div>
  );
}
